export const environment = {
    production: false,
    apiUrl: 'https://dev.api.tridimo.de/api/',
    useTokenAuth: true
};